import React from 'react';
import Home from './Components/home/home';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
